import Vue from "vue";
import Notification from "vue-notification";

Vue.use(Notification);
